export const headerStyle = () => {
    return {
        borderColor: '#a81933',
    };
};

export const columnStyle = () => {
    return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Name',
        sort: true,
        headerStyle: () => { return { width: '400px', ...headerStyle() }; },
    },
    {
        dataField: 'emailAddress',
        text: 'Email',
        sort: true,
        headerStyle: () => { return { width: '300px', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'instanceIds',
        text: 'Instance - Instance ID',
        sort: true,
        headerStyle: () => { return { width: '300px', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'role',
        text: 'Role',
        sort: true,
        headerStyle: () => { return { minWidth: '200px', ...headerStyle() }; },
        style: columnStyle
    },
    {
        dataField: 'type',
        text: 'Type',
        sort: true,
        headerStyle: () => { return { width: '200px', ...headerStyle() }; }
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];